import { create } from "zustand"
import { DLMSiteApplication } from "../../../../_models"
import { cloneDeep, findIndex } from "lodash"
import { isPopulatedArray } from "../../../../../../../components/helpers"
import { PropsWithNotes } from "../../../../../../../components/table"

interface SiteLabellingState {
  data : Array<PropsWithNotes<DLMSiteApplication>>
  hasNotes: boolean
  showAllNotes: boolean
  setData: (data: Array<DLMSiteApplication & {showNotes : boolean}>) => void
  toggleNotes: (id: number) => void
  toggleAllNotes: () => void
}

export const useSiteLabellingState = create<SiteLabellingState>()((set,get) => ({
  data: [],
  hasNotes: false,
  showAllNotes: true,
  setData: (data: Array<PropsWithNotes<DLMSiteApplication>>) => {
    let hasNotes = false;
    
    if (! (isPopulatedArray(data))) {      
      set({data, hasNotes});
      return;
    }

    for(const obj of data) {
      if (obj && (isPopulatedArray(obj?.notes) || isPopulatedArray(obj?.requestTerminateNotes))) {
        hasNotes = true;
        break;
      }
    }

    set({data, hasNotes, showAllNotes: hasNotes});
  },
  toggleNotes: (id: number) => {
    let data = cloneDeep(get().data);

    let _idx = findIndex(data, { id: parseInt(`0${id}`)});
    
    if (! (_idx > -1)) return;

    let row = data[_idx];
    Object.assign(row, { showNotes : row?.showNotes ? false : true});

    data.splice(_idx, 1, row);
    set({data, showAllNotes: false});  
  },
  toggleAllNotes:() => {
    let nextMode = (! get().showAllNotes);
    let data = cloneDeep(get().data).map( o => ({...o, showNotes: nextMode}));
    set({data, showAllNotes: nextMode});
  }
}));